module.exports = __webpack_public_path__ + "node_modules/angular-i18n/angular-locale_de-de.js";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=[path][name].[ext]&context=.!./~/angular-i18n/angular-locale_de-de.js
// module id = 402
// module chunks = 0